<template>
	<div>
		<a-page-header style="background: #fff;" title="门店详情" />
		<div style="background: #fff;padding:20px">
			<a-form-model ref="basicForm" :model="basicForm" :rules="basicFormRules" :label-col="{ span: 8 }" :wrapper-col="{ span: 10 }">
				<a-form-model-item label="门店名称" prop="storesName">
					<a-input v-model="basicForm.storesName" />
				</a-form-model-item>
				<a-form-model-item label="门店地址" prop="storesAddress">
					<a-input v-model="basicForm.storesAddress" />
				</a-form-model-item>
				<a-form-model-item label="联系电话" prop='storesTel'>
					<a-input v-model="basicForm.storesTel" />
				</a-form-model-item>
				<a-form-model-item label="定位经度" prop='storesLon'>
					<a-input v-model="basicForm.storesLon" />
				</a-form-model-item>
				<a-form-model-item label="定位纬度" prop='storesLat'>
					<a-input v-model="basicForm.storesLat" />
				</a-form-model-item>
				<a-form-model-item label="关联管理员微信">
					<a-select show-search option-label-prop="label" optionFilterProp="label" v-model="basicForm.wx">
						<a-select-option :value="item.value" :label="item.label" v-for="(item,index) in wxList" :key="index">
							<a-avatar :src="item.headpic" />
							{{item.label}}
							<a-icon type="man" style="color:#597ef7 ;" v-if="item.sex == 1" />
							<a-icon style="color:#f759ab ;" type="woman" v-if="item.sex == 2" />
						</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="备注" prop='storesIntro'>
					<a-input v-model="basicForm.storesIntro" />
				</a-form-model-item>
				<a-form-model-item label="门店状态">
					<a-switch checked-children="营业" un-checked-children="暂停" v-model="basicForm.isOpen" />
				</a-form-model-item>
				<a-form-model-item :wrapper-col="{ span: 10, offset: 8 }">
					<a-button type="primary" @click="basicSubmit">
						保存
					</a-button>
				</a-form-model-item>
			</a-form-model>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				wxList:[],
				basicForm: {},
				basicFormRules: {
					storesName: [{
						required: true,
						message: '请填写门店名称',
						trigger: 'blur'
					}],
					storesAddress: [{
						required: true,
						message: '请填写门店地址',
						trigger: 'blur'
					}],
					storesLon: [{
						required: true,
						message: '请填写定位经度',
						trigger: 'blur'
					}],
					storesLat: [{
						required: true,
						message: '请填写定位纬度',
						trigger: 'blur'
					}],
				},
			}
		},
		mounted() {
			this.id = this.$route.query.id
			this.getDetail()
			this.getWxList()
		},
		methods: {
			basicSubmit() {
				this.$refs.basicForm.validate(valid => {
					if (valid) {
						this.$http.post('/admin/index.php/admin/Shop/storesSave', {
							id: this.id,
							storesName: this.basicForm.storesName,
							storesAddress: this.basicForm.storesAddress,
							storesTel: this.basicForm.storesTel,
							storesLon: this.basicForm.storesLon,
							storesLat: this.basicForm.storesLat,
							storesIntro: this.basicForm.storesIntro,
							wx: this.basicForm.wx,
							isOpen: this.basicForm.isOpen
						}).then(res => {
							if (res.data.code == 1) {
								this.$message.success(res.data.msg)
								this.getDetail()
							} else {
								this.$message.error(res.data.msg)
							}
						})
					}
				});
			},

			getDetail() {
				this.$http.post('/admin/index.php/admin/Shop/storesInfo', {
					id: this.id,
				}).then(res => {
					if (res.data.code == 1) {
						this.basicForm = res.data.data
					}
				})
			},
			
			getWxList() {
				this.$http.get('/admin/index.php/admin/User/userFind').then(res => {
					if (res.data.code == 1) {
						this.wxList = res.data.data
					}
				})
			},
		},
	}
</script>

<style scoped="">
	.classTitle {
		padding: 20px;
		text-align: center;
		font-size: 20px;
	}

	.ant-upload-select-picture-card i {
		font-size: 32px;
		color: #999;
	}

	.ant-upload-select-picture-card .ant-upload-text {
		margin-top: 8px;
		color: #666;
	}

	.events {
		list-style: none;
		margin: 0;
		padding: 0;
	}

	.events .ant-badge-status {
		overflow: hidden;
		white-space: nowrap;
		width: 100%;
		text-overflow: ellipsis;
		font-size: 12px;
	}

	.notes-month {
		text-align: center;
		font-size: 28px;
	}

	.notes-month section {
		font-size: 28px;
	}

	/deep/ .ant-fullcalendar-header .ant-radio-group {
		display: none
	}

	/* For demo */
	.ant-carousel>>>.slick-slide {
		text-align: center;
		height: 160px;
		line-height: 160px;
		background: #364d79;
		overflow: hidden;
	}

	.ant-carousel>>>.custom-slick-arrow {
		width: 25px;
		height: 25px;
		font-size: 25px;
		color: #fff;
		background-color: rgba(31, 45, 61, 0.11);
		opacity: 0.3;
	}

	.ant-carousel>>>.custom-slick-arrow:before {
		display: none;
	}

	.ant-carousel>>>.custom-slick-arrow:hover {
		opacity: 0.5;
	}

	.ant-carousel>>>.slick-slide h3 {
		color: #fff;
	}
</style>
